// https://twitter.com/mattpocockuk/status/1625173884885401600
declare const brand: unique symbol;

export type Brand<T, TBrand extends string> = T & { [brand]: TBrand };

export function isBrand<T extends string>(_ignore: string): _ignore is T {
  return true;
}

export type ScheduledEvent = {
  startDate: DateString;
  endDate: DateString;
  startTime: TimeString;
  endTime: TimeString;
  title: string;
  text: string;
  ministry: string;
  location: string;
}

export type ScheduledScreen = {
  start: Date;
  end: Date;
  action: string;
  data?: string;
}

export type RawScheduledScreen = {
  startDate: DateTimeString;
  endDate: DateTimeString;
  startTime: DateTimeString;
  endTime: DateTimeString;
  action: string;
  data?: string;
}

export type DateTimeString = Brand<string, 'DateTimeString'>;
export type DateString = Brand<string, 'DateString'>;
export type TimeString = Brand<string, 'TimeString'>;

